import AbstractRequestTask from "../AbstractRequestTask";
import Launcher from '../../apa/Launcher';
import {DISABLE_MODAL_RETRIES} from '../../RequestManagerConstants';
import ChannelSingleton from './../../../components/Epg/ChannelsSingleton';

class LinealChannelsTask extends AbstractRequestTask {
    constructor(userId) {
        super();
        this.userId = userId;
    }

    getHeaders() {
        const params = super.getParams();

        const _headers = {
            'Content-Type': 'application/json',
        };

        if(params.user_token) {
            _headers["user-token"] = params.user_token;
        }
        
        return _headers;
    }

    getParams() {
        const params = super.getParams();
        delete params.HKS;
        delete params.user_token;
        delete params.api_version;
        delete params.user_id;
        return Object.assign({}, params, this.getExtraParams());
    }

    getExtraParams(){
        if (ChannelSingleton.hasTimeshiftAPA()) {
            return {
                "npvr": 1,
                "ts": 1,
            }
        }
        else{
            return {};
        }
    }

    getUrl() {
        const http = "https://";
        const url = Launcher.get("akamai_mfwk");
        return `${http}${url}/services/payway/v1/linealchannels`;
    }

    getShowErrorModal(){
        return DISABLE_MODAL_RETRIES;
    }

    success(data, b) {
        this.resolve(data);
    }

    getRetriesNumber() {
        return 0;
    }
}

export default LinealChannelsTask;



// WEBPACK FOOTER //
// ./src/requests/tasks/payway/LinealChannelsTask.js